module.exports = __webpack_public_path__ + "media/images/pages/home_featured/homepage-collection-grid-ddf5eaeed2586d0d425d82b8e987ea1d.png";